// extracted by mini-css-extract-plugin
export var content = "_5m-3";
export var list = "_5m-4";
export var settingsContent = "_5m-7";
export var settingsPanel = "_5m-8";
export var state = "_5m-6";
export var triggerBadge = "_5m-2";
export var triggerButton = "_5m-1";
export var triggerShell = "_5m-0";
export var unreadDot = "_5m-5";